export default {
  "content": "<rect width=\"40\" height=\"40\" rx=\"20\" fill=\"#F2F2F2\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 18c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm8 8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-10.82 2l11.2-16h2.44l-11.2 16h-2.44z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "40",
    "height": "40",
    "viewBox": "0 0 40 40",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};